"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ActorSupportsV2Damage = void 0;
const ActorType_1 = require("../actors/ActorType");
exports.ActorSupportsV2Damage = {
    [ActorType_1.ActorType.Assassin]: true,
    [ActorType_1.ActorType.Augur]: true,
    [ActorType_1.ActorType.AugurSoul]: true,
    [ActorType_1.ActorType.Avenger]: true,
    [ActorType_1.ActorType.Druid]: true,
    [ActorType_1.ActorType.Executioner]: true,
    [ActorType_1.ActorType.Gambler]: true,
    [ActorType_1.ActorType.GamblerBouncer]: true,
    [ActorType_1.ActorType.Gladiator]: true,
    [ActorType_1.ActorType.Monk]: true,
    [ActorType_1.ActorType.Necromancer]: true,
    [ActorType_1.ActorType.NecromancerLich]: true,
    [ActorType_1.ActorType.NecromancerMale]: true,
    [ActorType_1.ActorType.NecromancerReaper]: true,
    [ActorType_1.ActorType.NecromancerSkeleton]: true,
    [ActorType_1.ActorType.NecromancerSpirit]: true,
    [ActorType_1.ActorType.Ranger]: true,
    [ActorType_1.ActorType.RangerPet]: true,
    [ActorType_1.ActorType.Sunbreaker]: true,
    [ActorType_1.ActorType.Hammer]: true,
    [ActorType_1.ActorType.Tempest]: true,
    [ActorType_1.ActorType.ThunderCaller]: true,
    [ActorType_1.ActorType.Valkyrie]: true,
    [ActorType_1.ActorType.Vampire]: true,
    [ActorType_1.ActorType.Warrior]: true,
    [ActorType_1.ActorType.WarriorJoe]: true,
};
